interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      {eyebrow && (
        <span className="inline-block text-xs font-label tracking-[0.25em] uppercase text-accent-600 mb-3">
          {eyebrow}
        </span>
      )}
      <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
        {title}
      </h2>
      <span
        className={`block h-px w-12 bg-accent-400 mt-4 ${
          align === "center" ? "mx-auto" : ""
        }`}
      />
      {description && (
        <p
          className={`mt-4 text-sm md:text-base text-foreground-600 leading-relaxed ${
            align === "center" ? "max-w-2xl mx-auto" : "max-w-2xl"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}